/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lastgradesachunterricht2Inputs */



/**

* @param {_Field_Lastgradesachunterricht2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lastgradesachunterricht2 = /** @type {((inputs?: _Field_Lastgradesachunterricht2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lastgradesachunterricht2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Letzte Note im Fach Sachunterricht")
});
export { _field_lastgradesachunterricht2 as "_field_lastGradeSachunterricht" }